import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import SecondCertification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import PortraitTable from '@blade-sxp/portrait-management/pages/components/portrait-table.vue';
import PortraitCard from '@blade-sxp/portrait-management/pages/components/portrait-card.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { PortraitListShowEnum, PageQueryTypeEnum, LibraryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { queryPortraitLibPageList, batchDeletePortraits, portraitExport } from '@blade-sxp/portrait-management/api/portrait';
import { PortraitManagementDataModule } from '@blade-sxp/portrait-management/store/index';
import { cloneDeep } from 'lodash';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { SYSTEMCODE } from '@blade/common/constants/code';
import PortraitSearch from '@blade-sxp/portrait-management/components/portrait-search.vue';
const Webapi = {
    queryPortraitLibPageList,
    batchDeletePortraits,
    portraitExport,
};
let default_1 = class default_1 extends Vue {
    // 权限级别
    permissionlevel = permissionlevel;
    systemCode = SYSTEMCODE;
    // 图标默认尺寸
    iconSize = 12;
    // 判断使用
    viewModeTypeList = PortraitListShowEnum.LIST;
    viewModeTypeCard = PortraitListShowEnum.CARD;
    // 查询表单
    queryForm = {
        keyword: '',
        passCodeStatus: '',
        portraitStatus: '',
    };
    // 展示类型
    viewModeType = PortraitManagementDataModule.portraitViewModeType;
    // 展示模式
    viewModeList = [
        {
            key: PortraitListShowEnum.LIST,
            icon: 'portrait-list',
        },
        {
            key: PortraitListShowEnum.CARD,
            icon: 'portrait-card',
        },
    ];
    // 分页
    paginationParams = {
        page: 1,
        size: 32,
        total: 0,
    };
    lastPaginationParams = null;
    // 列表数据
    selectionList = PortraitManagementDataModule.portraitSelectionList;
    listData = [];
    // 是否批量操作
    isBatchOperation = PortraitManagementDataModule.portraitIsBatchOperation;
    loading = false;
    loadingExport = false;
    secondCertificationDialogVisible = false;
    isExport = false;
    get selectIsIndeterminate() {
        return this.selectionList.length > 0 && this.selectionList.length < this.listData.length;
    }
    get selectAllValue() {
        return this.selectionList.length === this.listData.length;
    }
    get allowOperate() {
        return this.selectionList.length > 0;
    }
    get hasBatchBtn() {
        switch (this.viewModeType) {
            case this.viewModeTypeList:
                return this.allowOperate;
            case this.viewModeTypeCard:
                return this.isBatchOperation;
            default:
                return false;
        }
    }
    selectionChange() {
        this.selectionList.some((item) => {
            if (item?.portraitStatus === 'INVALIDATING') {
                return (this.isExport = true);
            }
            this.isExport = false;
        });
        PortraitManagementDataModule.setPortraitSelectionList(this.selectionList);
    }
    paginationParamsChange() {
        // 加载策略 页码和页面尺寸发生变化时重新加载列表
        if (!this.lastPaginationParams)
            return this.getList();
        let curr = this.paginationParams;
        let last = this.lastPaginationParams;
        if (curr.page !== last.page || curr.size !== last.size)
            this.getList();
    }
    async created() {
        this.loading = true;
        this.$router.onReady(async () => {
            const query = this.$route.query;
            this.paginationParams.libIds = [+query.libId];
            await this.getList();
            this.selectionCheckChange(undefined, this.selectionList);
        });
    }
    async secondCertificationSuccess() {
        this.loadingExport = true;
        try {
            let result = await Webapi.portraitExport({
                ids: this.selectionList.map((s) => s.portraitId.toString()),
                portraitType: 'face',
            });
            window.location.href = result;
        }
        catch (error) {
            console.log('handleExportFunc error', error);
        }
        this.loadingExport = false;
    }
    selectAllChange(val) {
        this.selectionCheckChange(undefined, val ? [...this.listData] : []);
    }
    handleBatchOperation() {
        this.isBatchOperation = true;
        PortraitManagementDataModule.setPortraitIsBatchOperation(true);
    }
    selectionCheckChange(key, selectionList) {
        if (!key) {
            this.$refs.portraitTable?.selectionChange?.(selectionList);
            this.$refs.portraitCard?.selectionChange?.(selectionList);
        }
        switch (key) {
            case PortraitListShowEnum.LIST:
                this.$refs.portraitTable?.selectionChange?.();
                break;
            case PortraitListShowEnum.CARD:
                this.$refs.portraitCard?.selectionChange?.();
                break;
        }
    }
    // 监听导出
    async handleExportFunc() {
        this.secondCertificationDialogVisible = true;
    }
    handleCancel() {
        this.isBatchOperation = false;
        this.selectionCheckChange(undefined, []);
        PortraitManagementDataModule.setPortraitIsBatchOperation(false);
    }
    handleViewModeChange(key) {
        PortraitManagementDataModule.setPortraitViewModeType(key);
        this.viewModeType = key;
        this.selectionCheckChange(key);
    }
    // 获取数据
    async getList() {
        if (!this.paginationParams)
            return;
        this.loading = true;
        const { keyword, portraitStatus, passCodeStatus } = this.queryForm;
        try {
            let result = await Webapi.queryPortraitLibPageList({
                ...this.paginationParams,
                keywords: this.queryForm.keyword,
                status: portraitStatus === 'all' ? '' : portraitStatus,
                qrCodeState: passCodeStatus === 'all' ? '' : passCodeStatus,
            });
            this.paginationParams.total = result.total;
            this.listData = result.list;
            this.lastPaginationParams = cloneDeep(this.paginationParams);
        }
        catch (error) {
            console.log('getList error', error);
        }
        this.loading = false;
    }
    // 刷新列表
    refreshList() {
        if (!this.paginationParams)
            return;
        this.listData = [];
        if (this.paginationParams.page !== 1)
            this.paginationParams.page = 1;
        else
            this.getList();
    }
    handleNew() {
        const query = this.$route.query;
        this.$router.push({ name: 'portraitCreate', query: { ...query, type: PageQueryTypeEnum.CREATE } });
    }
    handleNewCommand(e) {
        if (e === 'singlePortrait') {
            this.handleNew();
        }
        else if (e === 'batchImport') {
            const query = this.$route.query;
            this.$router.push({ name: 'portraitImport', query: { ...query, libType: LibraryTypeEnum.PORTRAIT_LIBRARY } });
        }
    }
    async batchDeletePortraits() {
        try {
            this.loading = true;
            await Webapi.batchDeletePortraits({
                relationIds: this.selectionList.map((s) => s.relationId),
            });
            this.$message({
                customClass: 'success-message',
                message: this.$t('deletedSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.selectAllChange(false);
            this.refreshList();
        }
        catch (error) {
            console.log('batchDeletePortraits error', error);
            this.loading = false;
        }
    }
    handleBatchDelete() {
        if (this.loading)
            return;
        this.$elconfirm(`${this.$t('deletePortraitTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.batchDeletePortraits();
                }
            },
        });
    }
};
__decorate([
    Watch('selectionList')
], default_1.prototype, "selectionChange", null);
__decorate([
    Watch('paginationParams', { deep: true })
], default_1.prototype, "paginationParamsChange", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: lang,
        },
        components: {
            InputSearch,
            PortraitTable,
            PortraitCard,
            SecondCertification,
            AuthNewitem,
            PortraitSearch,
        },
    })
], default_1);
export default default_1;
